import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "../data/site";

const TeamOrdersCTA = () => {
  return (
    <section className="container-x py-20 md:py-28" data-testid="team-orders-cta">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 border border-line">
        <div className="md:col-span-6 lg:col-span-7 p-8 md:p-12 lg:p-16 flex flex-col justify-between">
          <div>
            <p className="overline mb-6">Team Orders</p>
            <h2 className="font-display uppercase text-4xl md:text-6xl tracking-tightest font-bold leading-[0.95]">
              For teams,
              <br />
              academies <span className="text-mute">and clubs.</span>
            </h2>
            <p className="mt-6 max-w-md text-mute leading-relaxed">
              Pritch offers team and academy order options, including club colour matching, bulk
              pricing and future custom colourways for serious football setups.
            </p>
          </div>
          <div className="mt-10 flex flex-wrap gap-3">
            <Link
              to="/team-orders"
              className="btn-primary"
              data-testid="team-orders-enquire-button"
            >
              Enquire about team orders <ArrowRight size={14} className="ml-2" />
            </Link>
            <Link to="/team-orders" className="btn-secondary">
              Bulk pricing
            </Link>
          </div>
        </div>
        <div className="md:col-span-6 lg:col-span-5 border-t md:border-t-0 md:border-l border-line">
          <div className="h-full aspect-[4/5] md:aspect-auto">
            <img
              src={IMAGES.teamOrders}
              alt="Footballs on training pitch"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamOrdersCTA;
